module.exports = __webpack_public_path__ + "img/expro2.5173c61.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/tpl/expro2.png
// module id = 3h1F
// module chunks = 57